import ReactPaginate from "react-paginate";
import {
  PaginationEllipsis,
  PaginationNext,
  PaginationPrevious,
} from "@/components/ui/pagination";
import { cn } from "@/lib/utils";

type Props = {
  itemsPerPage: number;
  count: number;
  onChange: (perPage: number, page?: number) => void;
  className?: string;
  currentPage?: number;
  options?: { value: number; label: string }[];
};

function ReactPagination({
  itemsPerPage,
  count,
  onChange,
  className,
  currentPage = 1,
  options = [
    { value: 5, label: "5" },
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ],
}: Props) {
  const pageCount = Math.ceil(count / itemsPerPage);

  const handlePageClick = (event: { selected: number }) => {
    onChange(itemsPerPage, event.selected + 1);
  };

  const handlePerPageChange = (newPerPage: number) => {
    // Réinitialiser à la première page lors du changement d'éléments par page
    onChange(newPerPage, 1);
  };

  return (
    <div
      className={cn(
        "flex items-center justify-center md:justify-between gap-5 lg:w-2/3 xl:w-1/2 ml-auto",
        className
      )}
    >
      <div className="hidden md:block">
        <label htmlFor="perPage" className="mr-3 text-sm">
          Par page
        </label>
        <select
          id="perPage"
          className="border border-gray-200 px-2 py-[2px] bg-white outline-primaryLight rounded"
          onChange={(e) => handlePerPageChange(Number(e.currentTarget.value))}
          value={itemsPerPage}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
      {pageCount > 1 && (
        <ReactPaginate
          containerClassName="flex items-center gap-2 pagination"
          activeClassName="bg-primary text-white"
          pageClassName="rounded-md w-8 h-8 flex items-center justify-center hover:bg-gray-100 cursor-pointer"
          pageLinkClassName="w-full h-full flex items-center justify-center"
          onPageChange={handlePageClick}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          pageCount={pageCount}
          breakLabel={<PaginationEllipsis />}
          nextLabel={<PaginationNext />}
          previousLabel={<PaginationPrevious />}
          renderOnZeroPageCount={null}
          forcePage={currentPage - 1}
        />
      )}
    </div>
  );
}

export default ReactPagination;
